export default "__VITE_ASSET__a2820473__"